module.exports = {
      id: "share-facebook-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#share-facebook",
      toString: function () {
        return this.url;
      }
    }